import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Body } from '../op-types';

/** Artifacts (copilot chat v2 item 6): a thread's stored interactive HTML documents. */
export function createChatbotArtifactsQueries(client: StoxlyClient) {
  return createQueryKeys('chatbotArtifacts', {
    // ['chatbotArtifacts', 'content', threadId, artifactId]
    content: (threadId: string, artifactId: string) => ({
      queryKey: [threadId, artifactId],
      queryFn: ({ signal }) =>
        client.chatbotArtifactsGetArtifact({ params: { id: threadId, artifactId }, signal }),
    }),
  });
}

export function createChatbotArtifactsMutations(client: StoxlyClient) {
  return {
    // Ask the model to repair an artifact whose script crashed in the viewer; the body carries
    // the error the viewer observed (a load-time crash the server can reproduce wins over it).
    repairArtifact: {
      mutationFn: (vars: {
        threadId: string;
        artifactId: string;
        body: Body<'chatbotArtifactsRepairArtifact'>;
      }) =>
        client.chatbotArtifactsRepairArtifact(vars.body, {
          params: { id: vars.threadId, artifactId: vars.artifactId },
        }),
    },
  };
}
